import { render, staticRenderFns } from "./IonSelect.vue?vue&type=template&id=585f4a5b&scoped=true"
import script from "./IonSelect.vue?vue&type=script&lang=js"
export * from "./IonSelect.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "585f4a5b",
  null
  
)

export default component.exports